var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "add_team_dialog",
      attrs: {
        modal: true,
        "modal-append-to-body": true,
        title: _vm.title,
        visible: _vm.show,
        "close-on-click-modal": false,
        direction: _vm.direction,
        "show-close": true,
        "close-on-press-escape": true,
        "before-close": _vm.clickCancel,
        wrapperClosable: false,
        "with-header": false
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c("header", [
        _c("span", [_c("i"), _vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn" },
          [
            _c("el-button", { on: { click: _vm.clickCancel } }, [
              _vm._v("取消")
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.submitForm("newTeamForm")
                  }
                }
              },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "newTeamForm",
          staticClass: "newTeamForm",
          attrs: { model: _vm.newTeamForm, rules: _vm.rules }
        },
        [
          _c(
            "div",
            { staticClass: "dialog_head" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "teamName", label: "小组名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "请输入小组名称",
                      maxlength: "20"
                    },
                    model: {
                      value: _vm.newTeamForm.teamName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.newTeamForm,
                          "teamName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "newTeamForm.teamName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "teamSlogan", label: "小组标语" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "请输入小组标语",
                      maxlength: "20"
                    },
                    model: {
                      value: _vm.newTeamForm.teamSlogan,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.newTeamForm,
                          "teamSlogan",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "newTeamForm.teamSlogan"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dialog_content" }, [
            _c("h2", [
              _vm._v("小组成员"),
              _c("p", [
                _vm._v(
                  "注：支持一人多岗，不支持多人一岗，请确保所有岗位均有成员担任，否则系统将提示“岗位不匹配”。"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table_wrap" },
              [
                _c(
                  "el-row",
                  { staticStyle: { margin: "0" }, attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "table_box table_box1",
                        attrs: { span: 10 }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "search_student" },
                          [
                            _c("span", [_vm._v("待选")]),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: { placeholder: "请输入学号和姓名" },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.getTeamStudent.apply(
                                    null,
                                    arguments
                                  )
                                }
                              },
                              model: {
                                value: _vm.noChoice,
                                callback: function($$v) {
                                  _vm.noChoice =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "noChoice"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            key: _vm.tableKey,
                            ref: "studentTable",
                            attrs: {
                              "row-key": _vm.getRowKey,
                              data: _vm.studentList,
                              fit: "",
                              "highlight-current-row": "",
                              height: _vm.pageTotal.total > 10 ? 275 : 330,
                              "header-cell-class-name": "tableHead"
                            },
                            on: { "selection-change": _vm.handleStudentChange }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                "reserve-selection": true,
                                width: "55"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "姓名",
                                align: "center",
                                prop: "studentName",
                                width: "95"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "学号", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.jobNumber))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.pageTotal.total > 10
                          ? _c("el-pagination", {
                              staticClass: "paginator",
                              staticStyle: { width: "380px" },
                              attrs: {
                                "current-page": _vm.pageTotal.currentPage,
                                background: "",
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.pageTotal.pageSize,
                                "pager-count": 5,
                                layout: "sizes, prev, pager, next",
                                total: _vm.pageTotal.total
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange,
                                "update:currentPage": function($event) {
                                  return _vm.$set(
                                    _vm.pageTotal,
                                    "currentPage",
                                    $event
                                  )
                                },
                                "update:current-page": function($event) {
                                  return _vm.$set(
                                    _vm.pageTotal,
                                    "currentPage",
                                    $event
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { span: 2 }
                      },
                      [
                        _c("el-button", {
                          staticStyle: { "margin-top": "110px" },
                          attrs: {
                            type: "primary",
                            disabled: !_vm.studentData.length,
                            icon: "el-icon-arrow-right",
                            circle: ""
                          },
                          on: { click: _vm.addStudent }
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          staticStyle: {
                            "margin-left": "0",
                            "margin-top": "10px"
                          },
                          attrs: {
                            type: "primary",
                            disabled: !_vm.selectedStudentData.length,
                            icon: "el-icon-arrow-left",
                            circle: ""
                          },
                          on: { click: _vm.removeStudent }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "table_box", attrs: { span: 12 } },
                      [
                        _c(
                          "el-table",
                          {
                            key: _vm.tableKey,
                            ref: "selectedStudentTable",
                            attrs: {
                              "row-key": _vm.getRowKey,
                              data: _vm.selectedStudentList,
                              fit: "",
                              "highlight-current-row": "",
                              height: _vm.height,
                              "header-cell-class-name": "tableHead"
                            },
                            on: {
                              "selection-change":
                                _vm.handleSelectedStudentChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                "reserve-selection": true,
                                width: "55"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "姓名",
                                align: "center",
                                prop: "studentName",
                                width: "65"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "学号", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.jobNumber))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "岗位分配", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "filter-item",
                                          attrs: {
                                            placeholder: "请选择",
                                            multiple: ""
                                          },
                                          model: {
                                            value: row.postId,
                                            callback: function($$v) {
                                              _vm.$set(row, "postId", $$v)
                                            },
                                            expression: "row.postId"
                                          }
                                        },
                                        _vm._l(_vm.postOption, function(item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.name,
                                              value: item.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ad7db8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ad7db8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/addTeamDialog.vue
// module id = null
// module chunks = 